import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FhirState {
  isInitialized: boolean;
  isInitializing: boolean;
  hasFailed: boolean;
  errorMessage: string | null;
  mrn: string | null;
  patient: any | null;
  practitioner: any | null;
  encounter: string | null;
}

const initialState: FhirState = {
  isInitialized: false,
  isInitializing: false,
  hasFailed: false,
  errorMessage: null,
  mrn: null,
  patient: null,
  practitioner: null,
  encounter: null,
};

const fhirSlice = createSlice({
  name: "fhir",
  initialState,
  reducers: {
    setFhirInitializing: (state) => {
      state.isInitializing = true;
      state.hasFailed = false;
      state.errorMessage = null;
    },
    setFhirInitialized: (
      state,
      action: PayloadAction<{ mrn?: string | null }>
    ) => {
      state.isInitialized = true;
      state.isInitializing = false;
      state.hasFailed = false;
      state.errorMessage = null;
      if (action.payload.mrn !== undefined) {
        state.mrn = action.payload.mrn;
      }
    },
    setFhirFailed: (state, action: PayloadAction<string>) => {
      state.isInitialized = false;
      state.isInitializing = false;
      state.hasFailed = true;
      state.errorMessage = action.payload;
      state.mrn = null;
      state.patient = null;
      state.practitioner = null;
      state.encounter = null;
    },
    resetFhirState: (state) => {
      state.isInitialized = false;
      state.isInitializing = false;
      state.hasFailed = false;
      state.errorMessage = null;
      state.mrn = null;
      state.patient = null;
      state.practitioner = null;
      state.encounter = null;
    },
    setFhirMrn: (state, action: PayloadAction<string | null>) => {
      state.mrn = action.payload;
    },
    setFHIRPatientAndPractitioner: (
      state,
      action: PayloadAction<{
        patient: any | null;
        practitioner: any | null;
        encounter: string | null;
      }>
    ) => {
      state.patient = action.payload.patient;
      state.practitioner = action.payload.practitioner;
      state.encounter = action.payload.encounter;
    },
  },
});

export const {
  setFhirInitializing,
  setFhirInitialized,
  setFhirFailed,
  resetFhirState,
  setFhirMrn, // Export new action
  setFHIRPatientAndPractitioner, // Export new action
} = fhirSlice.actions;

export default fhirSlice.reducer;
